function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var FilterDropdown = /*#__PURE__*/function () {
  function FilterDropdown(options) {
    _classCallCheck(this, FilterDropdown);
    this.container = document.querySelector(options.container) || null;
    this.opener = document.querySelector(options.opener) || null;
    this.dropdown = document.querySelector(options.dropdown) || null;
    this.linkSelector = document.querySelectorAll(options.linkSelector) || null, this.activeSelect = 'active';
    this.isOpenDropdown = false;
    this.dataLink = 'data-select-link';
    this.dataButton = 'data-select-button';
  }
  _createClass(FilterDropdown, [{
    key: "init",
    value: function init() {
      if (!this.container) return;
      this.handleClickOnSelectOpener();
    }
  }, {
    key: "handleClickOnSelectOpener",
    value: function handleClickOnSelectOpener() {
      var _this = this;
      if (!this.opener) return;
      this.opener.addEventListener('click', function (e) {
        if (!_this.isOpenDropdown) {
          _this.openDropdown();
        } else {
          _this.closeDropdown();
        }
      });
    }
  }, {
    key: "handleClickOnOption",
    value: function handleClickOnOption(callback) {
      var _this2 = this;
      this.linkSelector.forEach(function (link) {
        link.addEventListener('click', function (e) {
          e.preventDefault();
          var dataOptionValue = e.target.getAttribute(_this2.dataLink);
          _this2.opener.setAttribute(_this2.dataButton, dataOptionValue);
          _this2.opener.innerText = e.target.innerText;
          _this2.clearActiveStateForLinks();
          link.classList.add(_this2.activeSelect);
          _this2.closeDropdown();
          callback(dataOptionValue, _this2.dataLink);
        });
      });
    }
  }, {
    key: "openDropdown",
    value: function openDropdown() {
      this.isOpenDropdown = true;
      this.dropdown.classList.add(this.activeSelect);
    }
  }, {
    key: "closeDropdown",
    value: function closeDropdown() {
      this.isOpenDropdown = false;
      this.dropdown.classList.remove(this.activeSelect);
    }
  }, {
    key: "clearActiveStateForLinks",
    value: function clearActiveStateForLinks() {
      var _this3 = this;
      this.linkSelector.forEach(function (link) {
        link.classList.remove(_this3.activeSelect);
      });
    }
  }, {
    key: "setOptionByName",
    value: function setOptionByName(name) {
      var _this4 = this;
      if (!name) return;
      this.clearActiveStateForLinks();
      this.linkSelector.forEach(function (link) {
        if (link.dataset.selectLink === name) {
          link.classList.add(_this4.activeSelect);
        }
      });
    }
  }]);
  return FilterDropdown;
}();
export { FilterDropdown as default };